import axios from 'axios'
import store from '@/store'
import {findObjectIndex} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {filters, queryBuilder} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

let BASE_URL = 'https://service.firecloud.shop'

export default {
    namespaced: true,
    state: {
        servers: [],
        trash: [],
        pagination: [],
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        showUserServers({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.post(`${BASE_URL}/api/firecloud/show-user-servers/${form.user_id}?page=${form.page}&${query}`, form)
            return req
        },
        showServerDetail({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.post(`${BASE_URL}/api/firecloud/show-server-detail/${form.server_id}`, form)
            return req
        },
        serverAction({commit, state}, form) {
            let req = axios.post(`${BASE_URL}/api/firecloud/server-action/${form.server_id}`, form)
            return req
        },
        serverStatistic({commit, state}, form) {
            let req = axios.post(`${BASE_URL}/api/firecloud/server-statics/${form.server_id}`, form)
            return req
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}